import httpClient from './httpClient';

export default {
  getYears: tradeInSource => httpClient.post('/api/trade-in/years', { which: tradeInSource }),
  getMakes: (vehicle, tradeInSource) => httpClient.post('/api/trade-in/makes', { vehicle, which: tradeInSource }),
  getModels: (vehicle, tradeInSource) => httpClient.post('/api/trade-in/models', { vehicle, which: tradeInSource }),
  getTrims: (vehicle, tradeInSource) => httpClient.post('/api/trade-in/trims', { vehicle, which: tradeInSource }),
  getStyles: (vehicle, tradeInSource) => httpClient.post('/api/trade-in/styles', { vehicle, which: tradeInSource }),
  getStylesNoTrim: (vehicle, tradeInSource) =>
    httpClient.post('/api/trade-in/styles-no-trim', { vehicle, which: tradeInSource }),
  getReport: (payload, apiKey, externalId) => httpClient.post(`/api/trade-in/report/${apiKey}/${externalId}`, payload),
  getAcquireReport: (payload, apiKey, externalId) =>
    httpClient.post(`/api/trade-in/acquire-report/${apiKey}/${externalId}`, payload),
  getAutocomplete: (term, apiKey, externalId) =>
    httpClient.post(`/api/trade-in/autocomplete?s=${term}`, { apiKey, externalId }),
  // V2 endpoints for trade in carfax
  getYearsV2: (tradeInSource, apiKey, externalId) =>
    httpClient.get(
      `/api/v2/trade-in/years?apiKey=${encodeURIComponent(apiKey)}&externalId=${encodeURIComponent(externalId)}`
    ),
  getMakesV2: (vehicle, tradeInSource, apiKey, externalId) =>
    httpClient.get(
      `/api/v2/trade-in/years/${encodeURIComponent(vehicle.year)}/makes?apiKey=${encodeURIComponent(
        apiKey
      )}&externalId=${encodeURIComponent(externalId)}`
    ),
  getModelsV2: (vehicle, tradeInSource, apiKey, externalId) =>
    httpClient.get(
      `/api/v2/trade-in/years/${encodeURIComponent(vehicle.year)}/makes/${encodeURIComponent(
        vehicle.make
      )}/models?apiKey=${encodeURIComponent(apiKey)}&externalId=${encodeURIComponent(externalId)}`
    ),
  getTrimsV2: (vehicle, tradeInSource, apiKey, externalId) =>
    httpClient.get(
      `/api/v2/trade-in/years/${encodeURIComponent(vehicle.year)}/makes/${encodeURIComponent(
        vehicle.make
      )}/models/${encodeURIComponent(vehicle.model)}/trims?apiKey=${encodeURIComponent(
        apiKey
      )}&externalId=${encodeURIComponent(externalId)}`
    ),
  getEngineDetailsV2: (apiKey, externalId, vehicle) =>
    httpClient.get(
      `/api/v2/trade-in/details?apiKey=${encodeURIComponent(apiKey)}&externalId=${encodeURIComponent(
        externalId
      )}&year=${encodeURIComponent(vehicle.year)}&make=${encodeURIComponent(vehicle.make)}&model=${encodeURIComponent(
        vehicle.model
      )}&trim=${encodeURIComponent(vehicle.trim)}`
    ),
  getReportV2: (payload, apiKey, externalId) =>
    httpClient.get(
      `/api/v2/trade-in/report?apiKey=${encodeURIComponent(apiKey)}&externalId=${encodeURIComponent(
        externalId
      )}&year=${encodeURIComponent(payload.vehicle.year)}&make=${encodeURIComponent(
        payload.vehicle.make
      )}&model=${encodeURIComponent(payload.vehicle.model)}&trim=${encodeURIComponent(
        payload.vehicle.trim
      )}&engine=${encodeURIComponent(payload.vehicle.engine)}&fuelType=${encodeURIComponent(
        payload.vehicle.fuelType
      )}&transmission=${encodeURIComponent(payload.vehicle.transmission)}&driveTrain=${encodeURIComponent(
        payload.vehicle.drivetrain
      )}&bodyStyle=${encodeURIComponent(payload.vehicle.bodyStyle)}&boxLength=${encodeURIComponent(
        payload.vehicle.boxLength
      )}&odometer=${payload.vehicle.mileage}&province=${payload.province}&postalCode=${payload.postalCode}`
    ),
  getAcquireReportV2: (payload, apiKey, externalId) =>
    httpClient.get(
      `/api/v2/trade-in/acquire-report?apiKey=${encodeURIComponent(apiKey)}&externalId=${encodeURIComponent(
        externalId
      )}&year=${encodeURIComponent(payload.vehicle.year)}&make=${encodeURIComponent(
        payload.vehicle.make
      )}&model=${encodeURIComponent(payload.vehicle.model)}&trim=${encodeURIComponent(
        payload.vehicle.trim
      )}&engine=${encodeURIComponent(payload.vehicle.engine)}&fuelType=${encodeURIComponent(
        payload.vehicle.fuelType
      )}&transmission=${encodeURIComponent(payload.vehicle.transmission)}&driveTrain=${encodeURIComponent(
        payload.vehicle.drivetrain
      )}&bodyStyle=${encodeURIComponent(payload.vehicle.bodyStyle)}&boxLength=${encodeURIComponent(
        payload.vehicle.boxLength
      )}&odometer=${payload.vehicle.mileage}&province=${payload.province}&postalCode=${payload.postalCode}`
    ),
};
